export function clearValidation(form) {
    $.each(form.elements, function(index, elem){
        if($(elem).is('input') || $(elem).is('select') || $(elem).is('textarea')){
            if($(elem).attr('type') !== 'hidden'){
                $(elem).removeClass('is-invalid');
                $(elem).parent().closest('.form-group').removeClass('invalid');
                $(elem).parent().closest('.form-group').find('.error-text').text('').hide();
            }
        }
    });
}
